var render = function render(){var _vm=this,_c=_vm._self._c;return _c('register-admin',{ref:"registerAdmin",attrs:{"is-me":false,"title":'Δημιουργία Διαχειριστή Διεύθυνσης Επιστρατεύσεως'}})
}
var staticRenderFns = []

export { render, staticRenderFns }